/*
 * filename: routers.js
 * mainly responsivle for all routes component
 * change and sidebar routlist menu item
 * */

import React, { Component } from 'react';
// import classNames from 'classnames';
import { connect } from 'react-redux';
// import FloatingActionButton from 'material-ui/FloatingActionButton';
import history from '../history';
import Main from './main';
import { refreshAuthToken } from './../modules/logins/actions/LoginActions';
import { refreshAuthTokenSuperAdmin } from './../modules/Superadmin/logins/actions/LoginActions'; // for super admin
import { Route } from 'react-router-dom';
import { Router } from 'react-router';

class SidebarMenuRouters extends Component {
  constructor() {
    super();
    this.state = { menuOpen: true };
    this.menuCollapseWithResize = this.menuCollapseWithResize.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  // menu collapse when on mobile function
  menuCollapseWithResize() {
    if (window.innerWidth < 991) {
      this.setState({ menuOpen: false });
    }
    if (window.innerWidth > 991) {
      this.setState({ menuOpen: true });
    }
  }

  componentWillMount() {
    // @ CALL LOGIN API WITH LOCALSTORAGE ACCESS TOKEN ON PAGE refresh
    // * Please do not change this.
    let access_token = localStorage.getItem('access_token');
    let superUser = localStorage.getItem('superuser');
    if (superUser) {
      let prevUrl = history.location.pathname; // @get current url and send it as previous url on page refresh using ctl + F5
      this.props.refreshAuthTokenSuperAdmin(access_token, prevUrl);
    }
    if (access_token != null && this.props.loginUserInfo == null) {
      let prevUrl = history.location.pathname; // @get current url and send it as previous url on page refresh using ctl + F5
      this.props.refreshAuthToken(access_token, prevUrl);
    }
  }

  // Sidebar collapse when tablet
  componentDidMount() {

    window.addEventListener('resize', this.menuCollapseWithResize);

    if (window.innerWidth < 991) {
      this.setState({ menuOpen: false });
    }
  }

  // Sidebar collapse when tablet
  componentWillUnmount() {
    window.removeEventListener('resize', this.menuCollapseWithResize);
  }

  // Sidebar toggle
  toggleMenu() {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }));
  }

  render() {
    // const headerStyle = {
    //   background: this.props.colorHeader.color,
    // };

    // const containerStyle = {
    //   background: this.props.colorSidebar.color,
    // };

    // Page content class change based on menu toggle
    // const pageContent = classNames({
    //   'readmin-page-content': true,
    //   'menu-open': this.state.menuOpen,
    // });

    // Sidebar class based on bg color
    // const sidebarClass = classNames({
    //   'menu-drawer': true,
    //   'has-bg': true,
    // });

    // header left part with logo and toggle button
    // const HeaderLogoWithMenu = () => (
    //   <div className="an-header" style={headerStyle}>
    //     <div className="header-left">
    //       <a className="brand" href="">HealthCare</a>
    //       <FloatingActionButton
    //         mini={true}
    //         secondary={true}
    //         onClick={this.toggleMenu}
    //       >
    //         <i className="material-icons">format_indent_decrease</i>
    //       </FloatingActionButton>
    //     </div>
    //   </div>
    // );

    return (
      <Router history={history}>
        <div className="hgt100">
          <Route component={Main} />
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  return {
    colorHeader: state.headerActiveStyle,
    colorSidebar: state.sidebarActiveStyle,
    loginUserInfo: state.login.loginUserInfo,
  };
}

export default connect(mapStateToProps, { refreshAuthToken, refreshAuthTokenSuperAdmin })(SidebarMenuRouters);



// WEBPACK FOOTER //
// ./src/routers/routers.js